import { render, staticRenderFns } from "./AdminSwitch.vue?vue&type=template&id=d69281ee&scoped=true&"
import script from "./AdminSwitch.vue?vue&type=script&lang=js&"
export * from "./AdminSwitch.vue?vue&type=script&lang=js&"
import style0 from "./AdminSwitch.vue?vue&type=style&index=0&id=d69281ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d69281ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
